<template>
    <div class="azSize container">

          <H1 class="pageTitle isPoppins is-size-2">Analytics: &nbsp;
            
        </H1>
        <br><br>
        <img v-show="!noShow" src="@/assets/img/chevronsW.png" width="28" class="right3 is-size-2" /><span class="has-text-yell is-size-2">{{slink}}</span>
        <br>
       <!--  <button class="button" @click="call">Call</button><br><br> -->
        <div v-show="!noShow">
           <div class="has-text-white wideLimitWidth">This view shows the number of times your slink and subslinks have been used and a summary of the locations from which they were accessed. Select a date range to filter your results.</div>
          
           <div class="top10">*Values are updated several times per day</div><br> 
           <date-range-picker v-model="dateRange" class="has-text-dark" opens="'left'" :maxDate="new Date()" :minDate="new Date(2022, 3, 15)" @update="updateValues">
                <!--    header slot-->
                <div slot="header" slot-scope="header" class="slot">
                <!-- <h3>Calendar header</h3> <span v-if="header.in_selection"> - in selection</span> -->
                </div>
                <!--    input slot (new slot syntax)-->
                <template #input="picker"  style="min-width: 350px;">
                   <div>Date Range: {{ picker.startDate | date }} - {{ picker.endDate | date }} &nbsp;<i class="fa fa-angle-down"></i></div>
                </template>
                <!--    date slot-->
                <template #date="data">
                    <span class="small">{{ data.date | dateCell }}</span>
                </template>
                <!--    ranges (new slot syntax) -->
                <template #ranges="ranges">
                <div class="ranges">
                    <ul>
                    <li v-for="(range, name) in ranges.ranges" :key="name" @click="ranges.clickRange(range)">
                        <b>{{ name }}</b> <!-- <small class="text-muted">{{ range[0].toDateString() }} -
                        {{ range[1].toDateString() }}</small> -->
                    </li>
                    </ul>
                </div>
                </template>
                <!--    footer slot-->
                <div slot="footer" slot-scope="data" class="slot">
               <div class="has-text-centered bottom10">
                    <div>
                        <b class="text-black">Selected:</b> {{ data.rangeText }}
                    </div>
                    <div class="top10" style="margin-left: auto">
                        <a @click="data.clickApply" v-if="!data.in_selection" class="button is-warning is-small">APPLY</a>
                    </div>
               </div>
                </div>
            </date-range-picker>
    
            <br><br>
    
          <!--  <div class="input is-primary has-background-warning" style="width: 300px;">
                <select class="input is-warning has-text-weight-bold" style="width: 300px">
                     <option selected value="">Today</option>
                    <option  value="">This Week</option>
                     <option  value="">Last Week</option>
                      <option  value="">This Month</option>
                       <option  value="">Last Month</option>
               </select>
            </div> -->
            <div v-show="!loaded" id="loaderHolder" class="is-size-2">&nbsp;</div>
            <div v-show="loaded" class="">
                <div class="has-text-centered mainAnalyticBlock is-inline-block">
                    <div style="font-size: 120px" class="has-text-warning">{{rootTotal}}</div>
                    <div class="top-20"><img src="@/assets/img/chevronsT.png" width="22" class="right3" /><span class="title has-text-turk">{{slink}}</span></div>
                </div>
    
                 <div class="has-text-centered has-text-grey mainAnalyticBlock is-inline-block pad10" style="border-left: 3px solid #ffb227">
                    <div style="font-size: 120px">{{combinedTotal}}</div>
                    <div class="top-20"><span class="title has-text-grey">+subslinks</span></div>
                </div>
    
    
               
                <br>
    
      <div class="columns">
                   <div class="column" style="max-width: 600px">
                       <div class="analyticsDiv">
                            <div>
                                <div class="subTitle has-text-warning"><img src="@/assets/img/chevronsT.png" width="18" class="right3" />{{slink}} - <span class="has-text-white">{{findCombined(root.hits)}}</span></div>
                                <div class="left10" v-for="(c, ind) in root.hits" :key="ind">
                                    <span v-if="c.code != '*'">{{c.num}} - {{getCity(c.code)}}</span>
                                </div>
                            </div>
                            
                            <div class="bottom10"  v-for="(i, index) in subs" :key="index">
                                <div class="subTitle has-text-warning">:{{i.path.split(':')[1]}} - <span class="has-text-white">{{findCombined(i.hits)}}</span></div>
                                <div class="left10" v-for="(c, ind) in i.hits" :key="ind">
                                    <span v-if="c.code != '*'">{{c.num}} - {{getCity(c.code)}}</span>
                                </div>
                            </div>
                       </div>
                   </div>
        
                 <!--  <div class="column" >
                       <div class="analyticsDiv2">
                           <div class="is-size-3 has-text-warning"><b>Sources</b></div>
                           <br>
                          <table style="width: 300px">
                              <tr class="has-text-weight-bold is-size-5"> <td>(direct)</td>                <td align="right">201</td></tr>
                               <tr class="has-text-weight-bold  is-size-5"> <td>l.facebook.com</td>          <td align="right">40</td></tr>
                               <tr class="has-text-weight-bold  is-size-5"> <td>aax.amazon.com</td> <td align="right">10</td></tr>
                               <tr class="has-text-weight-bold  is-size-5"> <td>facebook.com</td>            <td align="right">8</td></tr>
                                <tr class="has-text-weight-bold  is-size-5"><td>example.com</td>             <td align="right">7</td></tr>
                          </table>
                       </div>
                  </div> -->
                 </div>
            </div>
        </div>
        <div v-show="noShow" class="has-text-dark">
           <b>Sorry, there is no slink data to show or you are not authorized to view this information.</b>
        </div>
        <br><br><br><br>


    </div>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
//you need to import the CSS manually
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import ModalClaims from '../components/ModalClaims.vue';
import { AZEventBus } from '../components/AZEventBus'
export default {
    components: {
    DateRangePicker,
    ModalClaims
},
    
    data: function(){
        return {
            locations: {},
            rootTotal: 0,
            combinedTotal: 0,
            root: {path: '', hits: [{code: '*', desc: '', num: 0}]},
            combined: [],
            subs: [],
            loaded: false,
            dateRange: {startDate: new Date(new Date().getFullYear(), 0, 1), endDate: new Date()},
            slink: '',
            noShow: false,
            inited: false
        }
    },

    mounted: function(){
        var self = this;
        this.slink = this.$route.params.slink

        if(this.slink == undefined || this.slink == ''){
            this.noShow = true
        }

       

        function init(){
            // TODO wire this into API
            self.inited = true
            
            setTimeout(function(){
                self.call()
            }, 200)
        }

        if(self.$root.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
            if(self.inited == false)
                init();
        });
        },

    methods: {
        updateValues(){
            this.call()
        },
        call: function(){
            
            var self =  this;
            
            
            this.rootTotal = 0
            this.combinedTotal = 0
            //this.locations = {}
            this.root.hits = [{code: '*', desc: '', num: 0}]
            this.subs = []
 
     
            function w(d){    
               
                az.addRemSpinner(false, 'id', 'loaderHolder');
                if(d.error && d.error == 'Not Authorized'){
                    self.noShow = true
                    return 
                }

                //TODO when backend returns not authorized, handle here
                
               
       
                self.loaded = true

            
               
                self.locations = d.locations

                self.rootTotal = d.paths[self.slink]['*'] 
                self.combinedTotal = d.paths[self.slink + '*']['*']

              

                var arr = [];
               
                for(var i in d.paths){

                    var hits = []
                    for(var c in d.paths[i]){
                        hits.push({code:c ,desc: d.locations[c], num: d.paths[i][c]})
                    }
                    hits.sort((a,b) => {
                        if(a.num > b.num) return -1
                        else if(b.num > a.num) return 1
                        else if(b.num == a.num) return 0
                    })
                    
                    arr.push({path: i, hits: hits})
                }

            

                self.root = arr.find(e => {
                    return e.path.split(':').length == 1 &&  e.path.split('*').length == 1
                })

               
                self.combined = arr.find(e => {
                    return e.path.split(':').length == 1 &&  e.path.split('*').length == 2
                })

                

                self.subs = arr.filter(e => {
                    return e.path.split(':').length == 2
                })

               

                self.subs.sort((a,b) => {
                    if(a.path > b.path) return 1
                    else if(b.path > a.path) return -1
                    else return 0

                })



            };

            function n(){
                az.addRemSpinner(false, 'id', 'loaderHolder');
            }
            az.addRemSpinner(true, 'id', 'loaderHolder');
            this.loaded = false
            this.$root.apiClient.get(`api/account/analytics/${this.slink}?metric=location&from=${this.sDay}&to=${this.eDay}`, {}, w, n)


           
        },

        findCombined: function(arr){
            return arr.find(e => {
                return e.code == '*'
            }).num
        },

        getCity: function(val){
            if(this.locations[val]){
                if(this.locations[val].city && this.locations[val].country)
                    return this.locations[val].city  + ', ' + this.locations[val].country
                else 
                    return this.locations[val].country
            } else {
                 return 'unspecified'
            }
               
        
        }

    },

    filters: {
        dateCell (value) {
        let dt = new Date(value)
            return dt.getDate()
        },
        date (val) {
            return val ? az.dateConvert(val) : ''
        }
    },

    computed: {
        sDay: function(){
            function treatAsUTC(date) {
                var result = new Date(date);
                result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
                return result;
            }

            var millisecondsPerDay = 24 * 60 * 60 * 1000;
            return Math.floor((treatAsUTC(new Date()) - treatAsUTC(this.dateRange.endDate)) / millisecondsPerDay);
            
        },

        eDay: function(){
            function treatAsUTC(date) {
                var result = new Date(date);
                result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
                return result;
            }

            var millisecondsPerDay = 24 * 60 * 60 * 1000;
            return Math.floor((treatAsUTC(new Date()) - treatAsUTC(this.dateRange.startDate)) / millisecondsPerDay);
            
        }
    }

   
}


</script>





// WEBPACK FOOTER //
// src/pages/Metrics.vue